module.exports = __webpack_public_path__ + "img/order.df8d3d4f.svg";